var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans",attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex text-center w-full h-16 items-center bg-slate-100"},[_c('div',{staticClass:"mx-auto text-center"},[_c('h2',{staticClass:"text-sm"},[_vm._v("Hayok Medicare ltd ©2025")])])])
}]

export { render, staticRenderFns }